import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
// ================================================================
// === 1. IMPORT the useAuth hook to access user and logout     ===
// ================================================================
import { useAuth } from './auth/AuthContext';

// --- Enhanced SVG Icon Components (No changes needed) ---
const LayoutIcon = () => ( 
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
  </svg> 
);
const BellIcon = () => ( 
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
  </svg> 
);
const UserCircleIcon = () => ( 
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <circle cx="12" cy="12" r="10"/>
    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4z"/>
    <path d="M6 21v-2a4 4 0 014-4h4a4 4 0 014 4v2"/>
  </svg> 
);
const LogoutIcon = () => ( 
  <svg xmlns="http://www.w.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
  </svg> 
);
const SettingsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);
const ChevronDownIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
  </svg>
);


// ================================================================
// === 2. REMOVED user and logout from the component's props    ===
// ================================================================
const Topbar = () => {
  // ================================================================
  // === 3. GET user and logout directly from the context         ===
  // ================================================================
  const { user, logout } = useAuth();
  
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [hasNotifications, setHasNotifications] = useState(true);
  const menuRef = useRef(null);

  // Update time every minute
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    console.log("Topbar received user from context:", user);
  }, [user]);

  // Click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    if (logout) {
      logout(); // This now calls the function from the AuthContext
    }
    // Navigate to login after logout is initiated
    navigate('/login');
  };
  
  // Use optional chaining for safety, in case the user object is momentarily null during loading
  const displayName = user?.username || user?.email || 'User';
  const userInitials = displayName.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  
  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', { 
      hour: '2-digit', 
      minute: '2-digit',
      hour12: true 
    });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString('en-US', { 
      weekday: 'short',
      month: 'short', 
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <>
      <style>{`
        .topbar {
          background: linear-gradient(135deg, #460229ff 0%, #5a0332 100%);
          color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 2rem;
          height: 70px;
          flex-shrink: 0;
          box-shadow: 0 4px 20px rgba(70, 2, 41, 0.3);
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          position: relative;
          z-index: 1000;
        }

        .topbar::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.05) 50%, transparent 100%);
          pointer-events: none;
        }

        .topbar-left, .topbar-right {
          display: flex;
          align-items: center;
          gap: 1.5rem;
          z-index: 1;
        }

        .logo-section {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          font-weight: 700;
          font-size: 1.25rem;
          letter-spacing: -0.025em;
        }

        .logo-icon {
          width: 2rem;
          height: 2rem;
          background: linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%);
          border-radius: 0.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #460229ff;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        .topbar-icon-button {
          background-color: transparent;
          border: none;
          color: #ffffff;
          padding: 0.75rem;
          border-radius: 0.75rem;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s ease;
          position: relative;
          backdrop-filter: blur(10px);
        }

        .topbar-icon-button:hover {
          background-color: rgba(255, 255, 255, 0.15);
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }

        .topbar-icon-button:active {
          transform: translateY(0);
        }

        .topbar-icon-button svg {
          width: 1.25rem;
          height: 1.25rem;
          transition: transform 0.2s ease;
        }

        .topbar-icon-button:hover svg {
          transform: scale(1.1);
        }

        .notification-button {
          position: relative;
        }

        .notification-badge {
          position: absolute;
          top: 0.25rem;
          right: 0.25rem;
          width: 0.5rem;
          height: 0.5rem;
          background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
          border-radius: 50%;
          border: 2px solid #460229ff;
          animation: pulse 2s infinite;
        }

        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.7; }
        }

        .pos-button {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
          padding: 0.75rem 1.25rem;
          border-radius: 0.75rem;
          font-weight: 600;
          cursor: pointer;
          border: none;
          color: #ffffff;
          transition: all 0.2s ease;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          border: 1px solid rgba(255, 255, 255, 0.1);
        }

        .pos-button:hover {
          background: linear-gradient(135deg, #334155 0%, #475569 100%);
          transform: translateY(-1px);
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
        }

        .pos-button svg {
          width: 1.125rem;
          height: 1.125rem;
        }

        .datetime-section {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          gap: 0.125rem;
          font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;
        }

        .time-text {
          font-weight: 700;
          font-size: 1.125rem;
          letter-spacing: 0.025em;
          text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
        }

        .date-text {
          font-weight: 500;
          font-size: 0.75rem;
          opacity: 0.8;
          letter-spacing: 0.05em;
          text-transform: uppercase;
        }

        .user-menu-container {
          position: relative;
        }

        .user-button {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          background: rgba(255, 255, 255, 0.1);
          padding: 0.5rem 1rem;
          border-radius: 2rem;
          font-weight: 600;
          cursor: pointer;
          border: 1px solid rgba(255, 255, 255, 0.2);
          color: #ffffff;
          transition: all 0.2s ease;
          backdrop-filter: blur(10px);
        }

        .user-button:hover {
          background: rgba(255, 255, 255, 0.2);
          transform: translateY(-1px);
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
        }

        .user-avatar {
          width: 2rem;
          height: 2rem;
          background: linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          font-size: 0.75rem;
          color: #460229ff;
          border: 2px solid rgba(255, 255, 255, 0.3);
        }

        .chevron-icon {
          width: 1rem;
          height: 1rem;
          transition: transform 0.2s ease;
        }

        .user-button[aria-expanded="true"] .chevron-icon {
          transform: rotate(180deg);
        }

        .dropdown-menu {
          position: absolute;
          top: calc(100% + 12px);
          right: 0;
          background: #ffffff;
          color: #1f2937;
          border-radius: 1rem;
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
          width: 240px;
          z-index: 50;
          border: 1px solid #f3f4f6;
          padding: 0.5rem;
          backdrop-filter: blur(20px);
          animation: dropdownSlide 0.2s ease-out;
        }

        @keyframes dropdownSlide {
          from {
            opacity: 0;
            transform: translateY(-8px) scale(0.95);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }

        .dropdown-header {
          padding: 1rem;
          border-bottom: 1px solid #f3f4f6;
          text-align: center;
        }

        .dropdown-avatar {
          width: 3rem;
          height: 3rem;
          background: linear-gradient(135deg, #460229ff 0%, #5a0332 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          color: #ffffff;
          margin: 0 auto 0.75rem;
          font-size: 1.125rem;
        }

        .dropdown-user-name {
          font-weight: 700;
          font-size: 1.125rem;
          color: #1f2937;
          margin-bottom: 0.25rem;
        }

        .dropdown-user-role {
          font-size: 0.875rem;
          color: #6b7280;
        }

        .dropdown-section {
          padding: 0.5rem 0;
        }

        .dropdown-item {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          padding: 0.75rem 1rem;
          font-size: 0.875rem;
          font-weight: 500;
          cursor: pointer;
          border-radius: 0.75rem;
          margin: 0.125rem 0;
          text-decoration: none;
          color: #374151;
          transition: all 0.15s ease;
        }

        .dropdown-item:hover {
          background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
          color: #1f2937;
          transform: translateX(4px);
        }

        .dropdown-item svg {
          width: 1.125rem;
          height: 1.125rem;
          color: #6b7280;
          transition: color 0.15s ease;
        }

        .dropdown-item:hover svg {
          color: #460229ff;
        }

        .dropdown-divider {
          height: 1px;
          background: linear-gradient(90deg, transparent 0%, #e5e7eb 50%, transparent 100%);
          margin: 0.5rem 0;
        }

        .logout-item {
          color: #dc2626;
        }

        .logout-item:hover {
          background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
          color: #b91c1c;
        }

        .logout-item svg {
          color: #dc2626;
        }

        .logout-item:hover svg {
          color: #b91c1c;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .topbar {
            padding: 0 1rem;
            height: 60px;
          }

          .topbar-left, .topbar-right {
            gap: 1rem;
          }

          .logo-section {
            font-size: 1.125rem;
          }

          .datetime-section {
            display: none;
          }

          .pos-button {
            padding: 0.5rem 0.75rem;
            font-size: 0.875rem;
          }

          .user-button {
            padding: 0.375rem 0.75rem;
          }

          .dropdown-menu {
            width: 200px;
            right: -1rem;
          }
        }

        @media (max-width: 480px) {
          .topbar {
            padding: 0 0.75rem;
          }

          .topbar-left, .topbar-right {
            gap: 0.75rem;
          }

          .logo-section span {
            display: none;
          }

          .pos-button span {
            display: none;
          }

          .user-button span {
            display: none;
          }
        }
      `}</style>
      
      <header className="topbar">
        <div className="topbar-left">
          <div className="logo-section">
            <div className="logo-icon">
              <LayoutIcon />
            </div>
            <span>Dashboard</span>
          </div>
        </div>
       
        <div className="topbar-right">
       
          <div className="datetime-section">
            <div className="time-text">{formatTime(currentTime)}</div>
            <div className="date-text">{formatDate(currentTime)}</div>
          </div>
          
          <button className="topbar-icon-button notification-button" title="Notifications">
            <BellIcon />
            {hasNotifications && <div className="notification-badge"></div>}
          </button>

          <div className="user-menu-container" ref={menuRef}>
            <button 
              className="user-button" 
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              aria-expanded={isDropdownOpen}
            >
              <div className="user-avatar">{userInitials}</div>
              <span>{displayName}</span>
              <ChevronDownIcon className="chevron-icon" />
            </button>

            {isDropdownOpen && (
              <div className="dropdown-menu">
                <div className="dropdown-header">
                  <div className="dropdown-avatar">{userInitials}</div>
                  <div className="dropdown-user-name">{displayName}</div>
                  <div className="dropdown-user-role">Administrator</div>
                </div>
                
                <div className="dropdown-section">
                  <a className="dropdown-item" href="#profile">
                    <UserCircleIcon />
                    <span>My Profile</span>
                  </a>
                  <a className="dropdown-item" href="#settings">
                    <SettingsIcon />
                    <span>Settings</span>
                  </a>
                </div>
                
                <div className="dropdown-divider"></div>
                
                <div className="dropdown-section">
                  <a className="dropdown-item logout-item" onClick={handleLogout}>
                    <LogoutIcon />
                    <span>Sign Out</span>
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      </header>
    </>
  );
};

export default Topbar;